'use strict';

var typography = require('../../../../../../../../../../_virtual/typography2.cjs');

var hasRequiredTypography;

function requireTypography () {
	if (hasRequiredTypography) return typography.__exports;
	hasRequiredTypography = 1;

	var NEUTRAL_INTENSITY = /*#__PURE__*/ function(NEUTRAL_INTENSITY) {
	    NEUTRAL_INTENSITY["neutral"] = "neutral";
	    NEUTRAL_INTENSITY["bold"] = "bold";
	    NEUTRAL_INTENSITY["subtle"] = "subtle";
	    return NEUTRAL_INTENSITY;
	}({});
	var INVERSE_INTENSITY = /*#__PURE__*/ function(INVERSE_INTENSITY) {
	    INVERSE_INTENSITY["neutral"] = "neutral";
	    INVERSE_INTENSITY["bold"] = "bold";
	    return INVERSE_INTENSITY;
	}({});

	typography.__exports.INVERSE_INTENSITY = INVERSE_INTENSITY;
	typography.__exports.NEUTRAL_INTENSITY = NEUTRAL_INTENSITY;
	
	return typography.__exports;
}

exports.__require = requireTypography;
//# sourceMappingURL=typography.cjs.map
